import { MapsAPILoader } from '@agm/core';
import { Component, ElementRef, NgZone, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { co } from '@fullcalendar/core/internal-common';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { JobService } from 'src/app/services/job/job.service';
// import {} from 'google.maps';
// declare var google: any;
// declare var google;
@Component({
  selector: 'app-add-location',
  templateUrl: './add-location.component.html',
  styleUrls: ['./add-location.component.scss']
})

export class AddLocationComponent {
  // latitude!:any;
  // longitude!:any;

  lat;
  lng;
  latitude;
  longitude;
  zoom!: number;
  address!: string;
  @ViewChild('search', { static: true }) public searchElementRef!: ElementRef;
  @ViewChild('property', { static: true }) public propertyName!: ElementRef;
  private geoCoder;
  public companyArr: any[] = [];
  public userType;
  public companyId!: string | number;
  public errorMsg!: string;
  public addressData: any = {
    city: "",
    country: "",
    latitude: "",
    longitude: "",
    address: ""
  };
  constructor(private dialogRef: MatDialogRef<AddLocationComponent>, private mapsAPILoader: MapsAPILoader, private appService: AppService,
    private jobService: JobService, private commonService: CommonService,
    private ngZone: NgZone) { }
  ngOnInit(): void {
    let userInfo = JSON.parse(this.appService.getData('training-portal.userInfo'))
    if (userInfo.u_typ == 0) {
      this.userType = "company";
    }
    else if (userInfo.u_typ == 1) {
      this.userType = "recruiter";
      this.list();
    }   else if (userInfo.u_typ == 3) {
      this.userType = "admin";

    }
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder;
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();
          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            this.address = "No Address Found."
            return;
          }
          this.latitude = place.geometry.location?.lat(); //set latitude, longitude and zoom
          this.longitude = place.geometry.location?.lng();
          this.zoom = 12;
          this.getAddress(this.latitude, this.longitude);
        });

      });
    });
  }
  setCurrentLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 8;
      });
    }
  }
  getAddress(latitude, longitude) {
    this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === 'OK') {
        let newArr: any[] = []
        newArr = results;
        if (this.searchElementRef.nativeElement.value == '') {
          for (let i = 0; i < newArr.length; i++) {
            let newAddress = newArr[i].formatted_address;
            if (!newAddress.includes('+') && (!newAddress.includes('Unnamed Road'))) {
              this.address = newAddress;
              // this.data["address"]=this.address;
              var value = this.address.split(",");
              var count = value.length;
              var country = value[count - 1];
              var city = value[count - 3];

              this.addressData["country"] = country.trim()
              this.addressData["city"] = city.trim()
              this.addressData["latitude"] = this.latitude
              this.addressData["longitude"] = this.longitude
              break;
            }
            else {
            }
          }
        }
        else {
          this.address = this.searchElementRef.nativeElement.value
          this.addressData["address"] = this.address;
          this.addressData["latitude"] = this.latitude
          this.addressData["longitude"] = this.longitude
          for (let i = 0; i < newArr.length; i++) {
            let newAddress: string = newArr[i].formatted_address;
            if (!newAddress.includes('+') && (!newAddress.includes('Unnamed Road'))) {
              this.address = newAddress;
              // this.data["address"]=this.address;
              var value = newAddress.split(",");
              var count = value.length;
              var country = value[count - 1];
              var city = value[count - 3];
              this.addressData["address"] = this.address;
              this.addressData["country"] = country.trim();
              this.addressData["city"] = city.trim();
              this.addressData["latitude"] = this.latitude;
              this.addressData["longitude"] = this.longitude;
              break;
            }
            else {
            }
          }
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }
    });
  }
  markerDragEnd($event: any) {
    this.searchElementRef.nativeElement.value = ""
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    this.getAddress(this.latitude, this.longitude);
  }
  list() {
    let data = {
      need: 1  // 1 = company list, 2 = address with company list
    }
    this.jobService.viewCompanyLocation(data).subscribe({
      next: (success: Object) => {
        if (success["status"] == 200) {
          this.companyArr = []
          this.companyArr = success["msg"]
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onSubmit() {
    let data = {
      add: this.addressData.address,
      city: this.addressData.city,
      country: this.addressData.country,
      lat: this.addressData.latitude,
      long: this.addressData.longitude,
    }
    if ((this.userType == 'recruiter') && ((this.companyId == undefined) || (this.companyId == "") || (this.companyId == null))) {
      this.errorMsg = 'Company is required';
    }
    else if (this.propertyName.nativeElement.value == "") {
      this.errorMsg = "Property Name is required";
    }
    else if (this.addressData.latitude == "" && this.addressData.longitude == "") {
      this.errorMsg = "Location is required";
    }
    else {
      this.errorMsg = ""
    }

    if (this.errorMsg) {
      return;
    }
    if (this.userType == "recruiter" && this.companyId) {
      data["co_i"] = this.companyId;
    }
    data["prop_n"]=this.propertyName.nativeElement.value;
    this.jobService.addLocation(data).subscribe({
      next: (success: Object) => {
        if (success["status"] == 200) {
          this.appService.showToastMessage('success',success["msg"]);
          this.dialogRef.close({'confirm':'yes','add':this.addressData.address});
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });    
  }
  onCancel() {
    this.dialogRef.close();
  }
}